import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getUpsellSubTitleStyles = isMobileScreen => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      paddingVertical: tokens.spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_12,
      flex: 1,
      alignItems: 'center'
    },
    iconSize: {
      width: isMobileScreen ? tokens.spacing.SPACING_28 : tokens.spacing.SPACING_32,
      height: isMobileScreen ? tokens.spacing.SPACING_28 : tokens.spacing.SPACING_32
    },
    benefitImage: {
      marginRight: tokens.spacing.SPACING_8,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4
    },
    subTitleText: {
      flex: 1
    }
  });
};